type Locale = 'fr' | 'it' | 'en' | 'de' | 'es';

/**
 * Checks if a feature should be active based on the given locale and a list of supported locales.
 * @param {string} locale - The locale code to check.
 * @param {Locale[]} supportedLocales - An array of supported locale codes.
 * @returns {boolean} - Returns true if the given locale is included in the list of supported locales.
 *
 * @example
 * const isActive = isFeatureActiveForLocale('fr', ['fr', 'it']);
 * console.log(isActive); // true
 *
 * const isInactive = isFeatureActiveForLocale('es', ['fr', 'it']);
 * console.log(isInactive); // false
 */
export function isFeatureActiveForLocale(locale: string, supportedLocales: Locale[]): boolean {
  if (typeof locale === 'string') {
    return supportedLocales.includes(locale.toLowerCase() as Locale);
  }
  return false;
}
